module.exports = " <div class=\"black-bgr\" (click)=\"modalClosed.emit( null )\"></div> <div class=\"link close\" (click)=\"modalClosed.emit( null )\"></div> <div id=\"print-modal\" class=\"body summary\"> <ng-content></ng-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/alert/alert.cmp.html
// module id = 858
// module chunks = 1